module.exports = "/_next/static/images/km-5946bdc72289eef3c983f82a18df1038.svg";